import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';
    
    try {
      const html = marked(value, { breaks: true, gfm: true });
      return this.sanitizer.bypassSecurityTrustHtml(html);
    } catch (error) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
  }
}